import { Injectable } from '@angular/core';
import { EpHttpService } from '../epHttpService/epHttp.service';
import { EpEnvironmentService } from '../epEnvironmentService/ep-environment.service';

@Injectable({
  providedIn: 'root'
})
export class GroupDetailsService {
  defaultTPAKey: string;

  constructor(private epHttpService: EpHttpService) { }

  getProspectGroupDetailsInfoData(groupId) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/groups/${groupId}`;
    return this.epHttpService.request('GET', url);
  }

  getClientOrRenewalGroupDetails(quoteId: string, subGroups?) {
    const includeSubgroups = subGroups ? true : false;
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/groups/${quoteId}/renewals?includeSubgroups=${includeSubgroups}`;
    return this.epHttpService.request('GET', url);
  }

  getClientOrRenewalGroupDetailsWithGroupId(groupId: string) {
    const url = `${EpEnvironmentService.baseUrl}groups/api/groups/${groupId}?onlyGroupsWithActivePlans=true`;
    return this.epHttpService.request('GET', url);
  }

  getClientGroupDetailsMedicalData(quoteId: string, groupNumber: string) {
    let url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/groups/med/${quoteId}/subgroups`;
    url += `?groupNumber=${groupNumber}`;
    return this.epHttpService.request('GET', url);
  }

  getClientGroupDetailsDentalAndVisionData(quoteId: string, groupNumber: string, isMedical: boolean) {
    let url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/groups/dnv/${quoteId}/subgroups`;
    url += `?groupNumber=${groupNumber}&hasMedical=${isMedical}`;
    return this.epHttpService.request('GET', url);
  }

  // nonQuoteGroup_Fun
  createGroup(body: any) {
    body.groupName = encodeURI(btoa(body.groupName));
    body.groupAddress1 = encodeURI(btoa(body.groupAddress1));
    body.groupAddress2 = encodeURI(btoa(body.groupAddress2));
    body.groupCity = encodeURI(btoa(body.groupCity));
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/groups`;
    return this.epHttpService.request('POST', url, { body });
  }

  getClientGroupDataByGrpNbr(groupNumber: string) {
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/groups/client/${groupNumber}/groupdetails`;
    return this.epHttpService.request('GET', url);
  }

  getClientGroupMedicalDataByGrpNbr(groupNumber: string) {
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/groups/med/client/${groupNumber}/subgroups`;
    return this.epHttpService.request('GET', url);
  }

  getClientGroupDentalAndVisionDataByGrpNbr(groupNumber: string) {
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/groups/dnv/client/${groupNumber}/subgroups`;
    return this.epHttpService.request('GET', url);
  }

  expireQuoteData(quoteId: any) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/quotes/${quoteId}/expire`;
    return this.epHttpService.request('PUT', url);
  }

  expireAllQuotes(groupId: number) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/quotes/${groupId}/expire-quotes`;
    return this.epHttpService.request('PUT', url);
  }

  getSubgroupInformation(groupNumber: string, subgroupCode: string) {
    const url = `${EpEnvironmentService.baseUrl}Groups/api/groups/${groupNumber}/subgroup/${subgroupCode}`;
    return this.epHttpService.request('GET', url);
   }

   getTransactions(groupId) {
    const url = `${EpEnvironmentService.baseUrl}Groups/api/admin/transactions/${groupId}`;
    return this.epHttpService.request('GET', url);
  }
}
